import { ChakraFlex, Text, Tag, TagProps } from '@equip.health/ui';

type Props = {
  label: string;
  value?: string;
  emptyStateText?: string;
  tagProps?: TagProps;
};
export const PatientStatusHeaderPopoverBodyRow = ({
  label,
  value,
  emptyStateText = 'Not set',
  tagProps,
}: Props) => {
  return (
    <ChakraFlex
      alignItems="center"
      aria-label={label}
      gap="24px"
      minWidth="160px"
    >
      <Text color="neutral.secondary" minWidth="160px" variant="caption">
        {label}
      </Text>
      <ChakraFlex flexDirection="column" gap="4px">
        <ChakraFlex alignItems="center" gap="8px">
          <Text color={value ? undefined : 'neutral.tertiary'} size="sm">
            {value || emptyStateText}
          </Text>
          {tagProps && <Tag {...tagProps} maxWidth="100%" />}
        </ChakraFlex>
      </ChakraFlex>
    </ChakraFlex>
  );
};
